"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BnsNamesOwnByAddressResponseToJSON = exports.BnsNamesOwnByAddressResponseFromJSONTyped = exports.BnsNamesOwnByAddressResponseFromJSON = void 0;
const runtime_1 = require("../runtime");
function BnsNamesOwnByAddressResponseFromJSON(json) {
    return BnsNamesOwnByAddressResponseFromJSONTyped(json, false);
}
exports.BnsNamesOwnByAddressResponseFromJSON = BnsNamesOwnByAddressResponseFromJSON;
function BnsNamesOwnByAddressResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'names': !runtime_1.exists(json, 'names') ? undefined : json['names'],
    };
}
exports.BnsNamesOwnByAddressResponseFromJSONTyped = BnsNamesOwnByAddressResponseFromJSONTyped;
function BnsNamesOwnByAddressResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'names': value.names,
    };
}
exports.BnsNamesOwnByAddressResponseToJSON = BnsNamesOwnByAddressResponseToJSON;
//# sourceMappingURL=BnsNamesOwnByAddressResponse.js.map